<template>
  <div
    class="relative bg-white p-6 flex items-start space-x-4 h-56 overflow-hidden"
  >
    <div class="">
      <slot name="icon" />
    </div>
    <div class="flex-1 flex flex-col">
      <h3 class="leading-6 text-xl font-bold text-gray-800">
        <slot name="name" />
      </h3>
      <div class="mt-1 text-sm text-gray-500 leading-4">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'get-started-item',
};
</script>

<style></style>
